__turbopack_context__.v({
  "buttonClose": "ButtonClose-module-scss-module__UE1Joa__buttonClose",
  "buttonCloseIcon": "ButtonClose-module-scss-module__UE1Joa__buttonCloseIcon",
  "buttonCloseIconWhite": "ButtonClose-module-scss-module__UE1Joa__buttonCloseIconWhite",
});
